import React from "react";
import { Pagination, RightSidePanel, SkeletonList } from "ui-components";
import "./IntegrationAppList.scss";
import AppCreation from "../AppCreation/AppCreation";
import { useTranslation } from "react-i18next";
import {
  scrollWindowTop,
  setInQueryParams,
} from "../../../../utils/Common/Constant";
import { useNavigate } from "react-router-dom";

type IntegrationAppListProps = {
  integrationModal: boolean;
  setIntegrationModal: React.Dispatch<React.SetStateAction<boolean>>;
  setRenderList: any;
  appList: any;
  totalCount: number;
  isLoading: boolean;
  setCurrentPage: any;
  pageSize: number;
  setPageSize: any;
  currentPage: number;
  getAppList: any;
};

const IntegrationAppList: React.FC<IntegrationAppListProps> = ({
  integrationModal,
  setIntegrationModal,
  setRenderList,
  appList,
  totalCount,
  isLoading,
  setCurrentPage,
  pageSize,
  setPageSize,
  currentPage,
  getAppList,
}) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const queryParams = new URLSearchParams(location.search);
  // App list APi

  return (
    <>
      <div className="integrationAppListSec">
        {integrationModal && (
          <RightSidePanel
            show={true}
            handleClose={() => {
              setIntegrationModal(false);
              setInQueryParams(queryParams, "createApp", false, navigate);
            }}
            title={t("SETTING.ADD_INTEGRATION")}
            className="integrationModal"
          >
            <AppCreation
              setIntegrationModal={setIntegrationModal}
              shouldListRender={setRenderList}
              setCurrentPage={setCurrentPage}
              getAppList={getAppList}
            />
          </RightSidePanel>
        )}
        {isLoading ? (
          <>
            {Array.from({ length: 5 }).map((_, index) => (
              <SkeletonList
                key={`skeleton-${index}`}
                numberOfTitles={1}
                numberofTextLines={0}
                titleSize={18}
                textSize={12}
                thumbnailHeight={80}
                thumbnailWidth={50}
                itemsGap={20}
              />
            ))}
          </>
        ) : (
          <>
            {appList.length > 0 ? (
              <>
                <div className="minHeight60s">
                  <div>
                    {appList?.map((app: any, key: any) => {
                      const activeClientId = queryParams.get("at");
                      const isActive = activeClientId === app?.clientId;
                      return (
                        <div
                          className={`integrationAppDetail ${isActive ? "active" : ""}`}
                          key={key}
                          onClick={() => {
                            setInQueryParams(
                              queryParams,
                              "at",
                              app?.clientId,
                              navigate,
                            );
                          }}
                        >
                          <div className="integrationAppName">
                            <h4>{app?.appName}</h4>
                          </div>
                        </div>
                      );
                    })}
                  </div>
                </div>
                <Pagination
                  className="pagination-bar"
                  currentPage={currentPage}
                  totalCount={totalCount > pageSize ? totalCount : 0}
                  pageSize={pageSize}
                  onPageChange={(page: number) => {
                    scrollWindowTop();
                    setCurrentPage(page);
                  }}
                  ofLabel={t("GENERAL.OF")}
                  resultLabel={t("GENERAL.RESULTS")}
                  setPageSize={setPageSize}
                />
              </>
            ) : (
              <>{""}</>
            )}
          </>
        )}
      </div>
    </>
  );
};
export default IntegrationAppList;
